import { render, staticRenderFns } from "./campaignMatchers.vue?vue&type=template&id=1358c049&scoped=true&"
import script from "./campaignMatchers.vue?vue&type=script&lang=js&"
export * from "./campaignMatchers.vue?vue&type=script&lang=js&"
import style0 from "./campaignMatchers.vue?vue&type=style&index=0&id=1358c049&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358c049",
  null
  
)

export default component.exports